export default {
	get(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'GET',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization' : `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			}
		});
	},
	post(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'POST',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization': `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			},
			body: JSON.stringify(data)
		});
	},
	patch(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'PATCH',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization': `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			},
			body: JSON.stringify(data)
		});
	},
	returningUserPost(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'POST',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization': `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			},
			body: JSON.stringify(data)
		});
	},
	postSetHeader(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'POST',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization': `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			},
			body: JSON.stringify(data)
		});
	},
	patchReauthorizeMono(url, data) {
		return fetch(process.env.VUE_APP_API_URL + url, {
			method: 'PATCH',
			headers: {
				'Client-Id': `${process.env.VUE_APP_CLIENT_ID}`,
				'Client-Key': `${process.env.VUE_APP_CLIENT_KEY}`,
				'Client-Secret': `${process.env.VUE_APP_CLIENT_SECRET}`,
				'Content-type': 'application/json;',
				'Authorization' : `Bearer ${data.token}`,
				'klump-public-key': `${data.klump_public_key}`
			}
		});
	}
};
